// 「多久以前」。wiki 的列表、边栏、回收站都用它，所以文案只有一处。

// 天数由**服务端**算好（`days_since_update` / `days_since_delete`）：
// `Date.current` 是 Rails 的 Asia/Shanghai，而浏览器时区可能是别的 —— 前端自己
// 算日历差就是把「两个『今天』不是同一个」那个坑搬到另一处（PR #7 刚因为它
// 红过 CI）。
//
// 只有「今天」这一格再细分到小时 / 分钟，而这一格**可以**在前端算：
// 「距今多少小时」是一段**时长**，与时区无关；「是不是同一个日历日」才与时区
// 有关。这条界线是这个文件存在的全部理由 —— 前者放前端安全，后者不安全。
export const freshness = (days: number, iso?: string | null): string => {
  if (days === 1) return '昨天';
  if (days > 1) return `${days} 天前`;

  // days === 0（服务端说是同一个日历日）。没给时间戳就只能说「今天」。
  if (!iso) return '今天';

  const minutes = Math.floor((Date.now() - new Date(iso).getTime()) / 60_000);
  // 负数：服务端与浏览器的钟差几秒就会出现，显示「-0 分钟前」比「刚刚」难看。
  if (minutes < 1) return '刚刚';
  if (minutes < 60) return `${minutes} 分钟前`;
  return `${Math.floor(minutes / 60)} 小时前`;
};

// 超过这个天数就在时间旁边点一个淡色的点。90 天是个「大概过了一季」的直觉数字。
//
// 它只呈现事实，不索取动作（§7.7 明确不做「审阅到期」那种要人点确认的东西：
// 单人应用里被索取的动作 100% 被忽略，然后那个标记自己变成噪音）。
//
// 设计稿把这个点画成琥珀色（--star），这里保持**灰色** —— §7.7 的原话是
// 「不是红色、不是徽标，是一个能被看见但不催人的灰点」。琥珀在这套暖米底色上
// 恰恰是最催人的那一档。
export const STALE_DAYS = 90;
